<mat-card class="end-page-form__card">
  <mat-card-title>
    <div class="title">
      <div class="eiq-id-badge">
        <fa-icon [icon]="faPartyHorn"></fa-icon>
      </div>
      <span class="fs__sm fw__500">"Thank you" Page</span>
    </div>
  </mat-card-title>
  <mat-card-content>
    <div [formGroup]="editorForm" class="end-page-form__content">
      <mat-slide-toggle [color]="'primary'" formControlName="useEndPageInd" [checked]="editorForm.value.useEndPageInd">
        Show the "Thank you" page
      </mat-slide-toggle>

      <div class="editor-question-form__input">
        <span class="label fs__md">Button Text</span>
        <mat-form-field appearance="outline">
          <input matInput formControlName="endButtonText" autocomplete="off" />
        </mat-form-field>
      </div>

      <div class="editor-question-form__input">
        <span class="label fs__sm">Message</span>
        <empathy-text-editor
          id="end-page"
          [settings]="textareaSettings"
          [control]="editorForm.get('endPageHtml')"
          [allowLineBreaks]="true"
        ></empathy-text-editor>
      </div>
    </div>
  </mat-card-content>
</mat-card>
